module.exports = __webpack_public_path__ + "img/jutaiyun.9b25e4c9.png";